import http from "../../http";
import request from "../../request";
import { getToken } from "@/utils/auth";

/** 房屋相关人员 — /resident/api/resident/housePerson */
const BASE = "/resident/api/resident/housePerson";

function resolveDownloadFilename(disposition, fallback) {
  if (!disposition) return fallback;
  const utf8 = /filename\*=utf-8''([^;]+)/i.exec(disposition);
  if (utf8 && utf8[1]) {
    try {
      return decodeURIComponent(utf8[1]);
    } catch (e) {
      return utf8[1];
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(disposition);
  return (plain && plain[1]) || fallback;
}

const person = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  /** 按房拆行分页（一人多房多行） */
  selectPageByHouse(r) {
    return http.get(`${BASE}/pageByHouse`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  /** 轻量修改人员标签（tagCodes 逗号分隔） */
  updateTagCodes(r) {
    const tagCodes = Array.isArray(r && r.tagCodes)
      ? (r.tagCodes || []).filter(Boolean).join(",")
      : (r && r.tagCodes) || "";
    return http.tip.post(`${BASE}/updateTagCodes`, {
      personId: r && r.personId,
      tagCodes,
    });
  },
  /** 轻量修改人房身份 */
  updateHouseRole(r) {
    return http.tip.post(`${BASE}/updateHouseRole`, r);
  },
  delete(r) {
    return http.confirm.post(`${BASE}/delete`, r);
  },
  listByHouse(r) {
    return http.get(`${BASE}/listByHouse`, r);
  },
  relationTypes() {
    return http.get(`${BASE}/relationTypes`);
  },
  tags() {
    return http.get(`${BASE}/tags`);
  },
  /** 下载人员导入模版 */
  async downloadImportTemplate({ estateCode, ruleId, fields } = {}) {
    const res = await request({
      url: `${BASE}/importTemplate`,
      method: "get",
      params: { estateCode, ruleId: ruleId || undefined, fields: fields || "" },
      responseType: "blob",
      headers: getToken() ? { Authorization: getToken() } : {},
    });
    const blob = res && res.data;
    if (!blob) throw new Error("模版下载失败");
    if (blob.type && blob.type.indexOf("application/json") >= 0) {
      const text = await blob.text();
      let desc = "模版下载失败";
      try {
        const json = JSON.parse(text);
        if (json && json.desc) desc = json.desc;
      } catch (e) {
        /* ignore */
      }
      throw new Error(desc);
    }
    const filename = resolveDownloadFilename(
      res.headers && (res.headers["content-disposition"] || res.headers["Content-Disposition"]),
      "人员导入模版.xlsx"
    );
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
  },
  /** 导入预览校验（不落库） */
  importPreview(formData) {
    return http.spin.postFile(`${BASE}/importPreview`, formData);
  },
  /** 确认导入（仅导入校验通过行） */
  importPersons(formData) {
    return http.spin.postFile(`${BASE}/import`, formData);
  },
};

export default person;
